// Value comparison for game data. Mirrors canonical()/same() in pocketbase/pb_hooks/lib/data-merge.js
// (empty = absent, sorted keys, numbers at float32 precision); schema.test.ts keeps both in step.

function isEmpty(v: unknown): boolean {
  return v === null || v === undefined || v === '' || (Array.isArray(v) && v.length === 0);
}

export function canonical(v: unknown): string {
  if (isEmpty(v)) return 'null';
  if (Array.isArray(v)) return '[' + v.map(canonical).join(',') + ']';
  if (typeof v === 'object') {
    const o = v as Record<string, unknown>;
    const keys = Object.keys(o)
      .filter((k) => !isEmpty(o[k]))
      .sort();
    return '{' + keys.map((k) => JSON.stringify(k) + ':' + canonical(o[k])).join(',') + '}';
  }
  if (typeof v === 'number') return isFinite(v) ? String(Number(v.toPrecision(7))) : 'null';
  return JSON.stringify(v);
}

export function same(a: unknown, b: unknown): boolean {
  return canonical(a) === canonical(b);
}
